<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :formsConfig="formsConfig"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="User"
        :baseView="baseView"
        primaryLabel="User"
        :secondaryLabel="baseView.id"
      />
    </template>

    <DxToolbar class="view-toolbar">
      <DxItem #default location="before" locate-in-menu="never">
        <div class="toolbar-label">
          <div v-if="baseView.mode == 'review' || baseView.mode == 'edit'">
            <b>{{ model.User.Name }}</b>
          </div>
        </div>
      </DxItem>
      <DxItem
        :options="toolbar.edit"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
        v-if="baseView.mode == 'review'"
      />
      <DxItem
        :options="toolbar.save"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
        v-if="baseView.mode != 'review'"
      />
    </DxToolbar>

    <div class="view-card responsive-paddings" id="userPanel">
      <form v-if="loadingCompleted">
        <DxForm
          :form-data.sync="model"
          :read-only="false"
          :show-colon-after-label="false"
          :show-required-mark="false"
          :show-validation-summary="false"
          :validation-group="formsConfig.validationGroup"
          :col-count-by-screen="colCountByScreen"
          label-location="left"
          :customizeItem="customizeItem"
          :items="items"
          ref="userForm"
          cssClass="cssClass"
        >
          <!-- SelectBox Template  -->
          <!-- <template #agentTemplate="{data}">
            <div class="custom-auto-complete">
              <span class="auto-complete-primary">{{data.DisplayName}}</span>
              <span class="auto-complete-secondary">{{data.Code}}</span>
            </div>
          </template>-->
        </DxForm>
      </form>
    </div>
  </gc-main-layout>
</template>

<script>
import validationEngine from "devextreme/ui/validation_engine";
import { FeatureStorage } from "../../../_services/storage";
import BaseViewMixin from "../../../v1/_mixins/base.view";
import { UserService } from "../../../_services/api/settings/user/user.service";

var UserTypeDataSource = [];
var AccessTypes = [" ", "Read", "Read / Write"];

export default {
  props: {},
  mixins: [BaseViewMixin],
  watch: {
    $route: {
      immediate: true,
      handler: "requestApplicationTypes",
    },
  },
  updated() {
    if (this.loadingCompleted && this.formsConfig.validationGroup)
      validationEngine.validateGroup(this.formsConfig.validationGroup);
  },
  components: {},
  data() {
    return {
      isAdminUser: false,
      isUserExistInLegacy: false,
      toolbar: {
        edit: {
          icon: "edit",
          onClick: () => {
            this.$router.push({
              path: `/user/edit/${this.model.User.Name}`,
            });
          },
          // visible : this.formsConfig.editableOption
        },
        save: {
          icon: "floppy",
          validationGroup: "formsData",
          onClick: async (e) => {
            this.$logger.trackEventButtonClickSave();
            const result = await e.validationGroup.validate();
            if (result.isValid) {
              this.showLoading(true);
              var ApplicationUserManagement = {
                ApplicationUserCode: this.model.User.Name,
                ApplicationUserManagementFeatures: {
                  ApplicationUserManagementFeature: [],
                },
                ApplicationUserTypeCode: this.model.User.Type,
                Inactive: this.model.User.Status,
                UseExistingApplicationUserTypeCode: "",
              };
              var payload = {
                Mode: this.baseView.mode,
                ActiveInstanceCount: 0, //
                DateInto: new Date(), //
                Username: this.model.User.Name,
                FirstName: this.model.User.FirstName,
                LastName: this.model.User.LastName,
                Password: this.model.User.Password,
                Email: this.model.User.Email,
                Template: this.model.User.Template,
                Inactive: this.model.User.Status,
                ApplicationUserManagement,
                UserSetting: {
                  BranchAccess: "All",
                  CompanyAccess: "All",
                  DivisionAccess: "All",
                  UpdateBOMStdCost: false,
                  UpdateBOMTStdCost: false,
                  IsCrmManager: false,
                },
              };

              if (this.model.featureAccess == null) {
                this.model.featureAccess = {};
              }

              for (let index = 0; index < this.payLoadHelper.length; index++) {
                if (
                  this.model.featureAccess[
                    this.payLoadHelper[index].ApplicationFeatureCode
                  ] == "Read"
                ) {
                  this.payLoadHelper[index].ReadPermission = "Y";
                  this.payLoadHelper[index].HasReadWritePermission = "N";
                  this.payLoadHelper[index].WritePermission = "N";
                  payload.ApplicationUserManagement.ApplicationUserManagementFeatures.ApplicationUserManagementFeature.push(
                    this.payLoadHelper[index]
                  );
                } else if (
                  this.model.featureAccess[
                    this.payLoadHelper[index].ApplicationFeatureCode
                  ] == "Read / Write"
                ) {
                  this.payLoadHelper[index].ReadPermission = "Y";
                  this.payLoadHelper[index].HasReadWritePermission = "Y";
                  this.payLoadHelper[index].WritePermission = "Y";
                  payload.ApplicationUserManagement.ApplicationUserManagementFeatures.ApplicationUserManagementFeature.push(
                    this.payLoadHelper[index]
                  );
                }
              }
              this.saveUserDetails(payload);
            } else {
              // this.displayValidationSummary();

              this.addErrorMessagesFromValidationResult(result);
              this.displayValidationSummary();
              validationEngine.validateGroup(this.formsConfig.validationGroup);
            }
          },
        },
      },
      colCountByScreen: {
        xs: 1,
        sm: 1,
        md: 1,
        lg: 1,
      },
      model: {
        isUserExistInLegacy: false,
        User: {
          Name: "",
          FirstName: "",
          LastName: "",
          Password: "",
          Email: "",
          Template: "",
          Status: "Active",
          Type: "",
          TypeCode: null,
        },
        userTypes: [],
        featureAccess: {},
      },

      items: [
        {
          itemType: "group",
          caption: "",
          colCount: 3,
          items: [
            {
              dataField: "User.Name",
              editorOptions: {
                editorType: "dxTextBox",
                onValueChanged: async ({ value }) => {
                  this.showLoading(true);
                  await UserService.getUserByUsernameAndValidateCxUser(value)
                    .then(({ data }) => {
                      this.setFeildValues(data);
                      this.showLoading(false);
                    })
                    .catch((err) => {
                      this.displayServerError(err, "User Already exist");
                      this.showLoading(false);
                    });
                },
                // readOnly: this.baseView.mode === "edit",
              },
              label: {
                text: "User Name",
              },
              validationRules: [
                {
                  type: "required",
                  message: "User Name is required",
                },
              ],
            },
            {
              dataField: "User.Email",
              editorOptions: {
                editorType: "dxTextBox",
                maxLength: 200,
                readOnly: this.isUserExistInLegacy,
              },
              label: {
                text: "Email",
              },
              validationRules: [
                {
                  type: "email",
                  message: "Invalid Email Address",
                },
              ],
            },
            {
              dataField: "User.Status",
              id: "status-selectBox",
              validationRules: [
                {
                  type: "required",
                  message: "User Status is required",
                },
              ],
              editorType: "dxSelectBox",
              editorOptions: {
                items: [
                  {
                    value: "N",
                    text: "Active",
                  },
                  {
                    value: "Y",
                    text: "Inactive",
                  },
                ],
                valueExpr: "value",
                displayExpr: "text",
              },
              label: {
                text: "Status",
              },
            },
            {
              dataField: "User.FirstName",
              editorOptions: {
                maxLength: 50,
                editorType: "dxTextBox",
                readOnly: this.isUserExistInLegacy,
              },
              label: {
                text: "First Name",
              },
              // validationRules: [
              //   {
              //     type: "required",
              //     message: "First Name is required",
              //   },
              // ],
            },
            {
              dataField: "User.LastName",
              editorOptions: {
                readOnly: this.isUserExistInLegacy,
                editorType: "dxTextBox",
                maxLength: 50,
              },
              label: {
                text: "Last Name",
              },
              // validationRules: [
              //   {
              //     type: "required",
              //     message: "Last Name is required",
              //   },
              // ],
            },
            {
              dataField: "User.Password",
              editorOptions: {
                mode: "password",
                editorType: "dxTextBox",
                maxLength: 50,
              },
              // visible: !(
              //   // this.isUserExistInLegacy || this.baseView.mode !== "create"
              // ),
              validationRules: [],
              label: {
                text: "Password",
              },
            },
            {
              dataField: "User.Type",
              id: "user-type-selectBox",
              caption: "User Type",
              // editorType: "dxSelectBox",
              // editorOptions: {
              //   items: UserTypeDataSource,
              //   valueExpr: "Code",
              //   displayExpr: "DisplayName",
              //   onItemClick: this.UserTypeChange
              // },
              editorType: "dxSelectBox",
              editorOptions: {
                dataSource: UserService.dataSourceConfig({
                  url: "api/ApplicationUserType",
                  select: ["Code", "DisplayName"],
                  orderby: "Sequence asc, Code asc",
                }),
                valueExpr: "Code",
                displayExpr: "DisplayName",
                searchExpr: ["Code", "DisplayName"],
                searchMode: "contains",
                showClearButton: true,
                onItemClick: this.UserTypeChange,
                // itemTemplate: "agentTemplate",
                searchEnabled: true,
              },
              label: {
                text: "User Type",
              },
              validationRules: [
                {
                  type: "required",
                  message: "User Type is required",
                },
                {
                  type: "async",
                  validationCallback: this.userTypeExistsRuleCallback,
                  message: "User Type does not exist",
                },
              ],
            },
          ],
        },
        {
          itemType: "group",
          caption: "Feature Access",
          colCountByScreen: {
            xs: 1,
            sm: 1,
            md: 2,
            lg: 2,
          },
          // 1 work center
          // 2 moduel
          // 3 screens
          items: [],
        },
      ],
      position: { of: "#userPanel" },
      loadingVisible: true,
      showIndicator: true,
      shading: true,
      showPane: true,
      hideOnOutsideClick: false,
      featureAccess: {},
      payLoadHelper: [],
    };
  },
  methods: {
    setFeildValues(data) {
      if (data.value.length != 0) {
        this.model.User.FirstName = data.value[0].FirstName;
        this.model.User.LastName = data.value[0].Surname;
        this.model.User.Email = data.value[0].Email;
        this.model.User.Template = data.value[0].Template;
        this.model.User.Status = data.value[0].Inactive;
        // this.model.User.Type = "Standard";
        // var e = {
        //   itemData: {
        //     Code: "Standard",
        //   },
        // };
        // this.UserTypeChange(e);
        // this.items[0].items[6].editorOptions.readOnly =
        this.setIsUserExistInLegacy(true);
      } else {
        this.model.User.FirstName = "";
        this.model.User.LastName = "";
        this.model.User.Email = "";
        this.model.User.Template = "";
        this.setIsUserExistInLegacy(false);
      }
    },
    setIsUserExistInLegacy(value) {
      this.isUserExistInLegacy = value;
    },
    userTypeExistsRuleCallback(params) {
      return new Promise((resolve) => {
        UserService.getUserTypeByCode(params.value).then((response) => {
          if (response.data.value.length > 0) {
            this.model.User.TypeCode = response.data.value[0].Code;
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
    async UserTypeChange(e) {
      if (this.baseView.mode != "review") {
        this.showLoading(true);
        this.model.User.TypeCode = e.itemData.Code;
        await UserService.getUserManagement(
          this.model.User.TypeCode,
          this.baseView.id
        ).then((response) => {
          this.showLoading(false);
          this.generateFormData(
            response.data.ApplicationUserManagementFeatures
              .ApplicationUserManagementFeature
          );
        });
      }
    },
    async saveUserDetails(payload) {
      // await UserService.saveUser(true, payload)
      await UserService.saveLegacyCxUser(payload)
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          // this.showLoading(false);
          // eslint-disable-next-line no-console
          // this.$logger.debug("saveUserDetails", response);
          this.$notify("User saved successfully", "success");
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/user/review/${this.model.User.Name}`,
          });
        })
        .catch(async (error) => {
          this.displayServerError(error, "User saved Failed");

          // -- Multiple Message handling - if needed
          // var errors = [];
          // var message = error.data;
          // if (message.error.innererror) {
          //   var unformattedErrors = message.error.innererror.message.split(
          //     "entity."
          //   );
          //   for (const elment of unformattedErrors) {
          //     if (elment !== "") {
          //       var thisError = elment.split(":");
          //       await errors.push({
          //         Name: thisError[0].trim(),
          //         ErrorMessage: thisError[1].trim().replace("\r\n", "<br/>")
          //       });
          //     }
          //   }
          // }
          // -------------------------
        });
    },
    generateFormData(data) {
      this.model.featureAccess = {};
      this.items[1].items = [];

      var workCenter = data.filter((x) => x.Type == "Work Centre");
      // var workCenter = data;
      this.payLoadHelper = [];
      for (let x = 0; x < workCenter.length; x++) {
        var workType = {};
        workType.itemType = "group";
        workType.caption = workCenter[x].DisplayName;
        workType.items = [];
        var moduleCenter = workCenter[
          x
        ].ApplicationUserManagementFeatures.ApplicationUserManagementFeature.filter(
          (x) => x.Type == "Module"
        );
        for (let y = 0; y < moduleCenter.length; y++) {
          var moduleType = {};
          moduleType.itemType = "group";
          moduleType.caption = moduleCenter[y].DisplayName;
          moduleType.items = [];
          var screenCenter = moduleCenter[
            y
          ].ApplicationUserManagementFeatures.ApplicationUserManagementFeature.filter(
            (x) =>
              x.Type == "Advanced Master Screen" ||
              x.Type == "Screen" ||
              x.Type == "Grid Report" ||
              x.Type == "Formatted Report" ||
              x.Type == "Transaction Report" ||
              x.Type == "Grid Report" ||
              x.Type == "Screen Setting" ||
              x.Type == "Settings Screen"
          );
          for (let z = 0; z < screenCenter.length; z++) {
            var screenType = {};
            screenType.label = {
              text: screenCenter[z].DisplayName,
            };
            screenType.editorType = "dxSelectBox";

            var selectedValue = AccessTypes[0];
            if (
              (screenCenter[z].ReadPermission == "N" &&
                screenCenter[z].WritePermission == "N") ||
              (this.model.User.TypeCode == "Standard" &&
                this.baseView.mode != "review" &&
                this.baseView.mode != "edit")
            ) {
              selectedValue = null;
            } else if (
              screenCenter[z].ReadPermission == "Y" &&
              screenCenter[z].WritePermission == "Y"
            ) {
              selectedValue = AccessTypes[2];
            } else if (
              screenCenter[z].ReadPermission == "Y" &&
              screenCenter[z].WritePermission == "N"
            ) {
              selectedValue = AccessTypes[1];
            }

            if (this.model.User.TypeCode != "Standard") {
              screenType.disabled = true;
            }

            screenType.dataField =
              "featureAccess." + screenCenter[z].ApplicationFeatureCode;
            this.payLoadHelper.push(screenCenter[z]);

            screenType.editorOptions = {
              items: AccessTypes,
              value: selectedValue,
            };

            moduleType.items.push(screenType);
          }
          workType.items.push(moduleType);
        }
        this.items[1].items.push(workType);
      }

      if (this.$refs["userForm"]) {
        let form = this.$refs["userForm"].instance;
        form.repaint();

        // This fixes up case sensitity issues with remote data in SelectBox
        this.validateFormConfig(this.$refs["userForm"].instance);

        validationEngine.validateGroup(this.formsConfig.validationGroup);
      }

      this.loadingCompleted = true;
    },
    async requestApplicationTypes() {
      this.showLoading(true);
      await UserService.getUserTypes()
        .then(async (response) => {
          UserTypeDataSource = response.data.value;
          this.items[0].items[6].editorOptions.items = UserTypeDataSource;
          // if (this.baseView.mode != "review") {
          //   this.items[0].items[6].editorOptions.readOnly =
          //     this.isAdminUser == false;
          // }

          if (this.baseView.mode == "edit") {
            this.items[0].items[0].editorOptions.readOnly = true;
            this.items[0].items[5].editorOptions.readOnly =
              this.isAdminUser == false;
          } else if (this.baseView.mode == "create") {
            this.items[0].items[5].validationRules.push({
              type: "required",
              message: "Password is required",
            });
          }

          if (this.baseView.mode == "review" || this.baseView.mode == "edit") {
            await UserService.getUserTypeCode(this.baseView.id).then(
              (response) => {
                this.model.User.TypeCode =
                  response.data.value[0].ApplicationUserTypeCode;
                this.model.User.Type = UserTypeDataSource.find(
                  (x) => x.Code == this.model.User.TypeCode
                ).DisplayName;
              }
            );
            this.model.User.Name = this.baseView.id;
          } else {
            this.model.User.Type = UserTypeDataSource.find(
              (x) => x.Code == "Standard"
            ).DisplayName;
            this.model.User.TypeCode = UserTypeDataSource.find(
              (x) => x.Code == "Standard"
            ).Code;
          }

          await UserService.getUserManagement(
            this.model.User.TypeCode,
            this.baseView.id
          )
            .then((response) => {
              this.model.User.Status = response.data.Inactive;
              this.showLoading(false);
              this.generateFormData(
                response.data.ApplicationUserManagementFeatures
                  .ApplicationUserManagementFeature
              );
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error) => {
              // this.$logger.debug("error", error);
            });
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error) => {
          // this.$logger.debug("error", error);
          this.showLoading(false);
          this.loadingCompleted = true;
        });
    },
    backButtonFunction() {
      this.$router.push({
        path: "/user",
      });
    },
  },
  mounted() {
    // check logged user
    this.isAdminUser = FeatureStorage.getUserType().includes("Administrator");
    this.items[0].items[6].editorOptions.readOnly = this.isAdminUser == false;

    if (
      (this.baseView.mode == "review" || this.baseView.mode == "edit") &&
      this.$refs["userForm"]
    ) {
      // this.items[0].items[0].visible = false;
      let form = this.$refs["userForm"].instance;
      form.repaint();
    }
  },
  async created() {
    this.toolbar.edit.visible = this.formsConfig.editableOption;
    if (this.baseView.mode !== "create") {
      var { data } = await UserService.getUserByUsername(this.baseView.id);
      this.model.User.FirstName = data.value[0].FirstName;
      this.model.User.LastName = data.value[0].LastName;
      this.model.User.Email = data.value[0].Email;
      this.model.User.Template = data.value[0].Template;
    }
    if (this.loadingCompleted)
      validationEngine.validateGroup(this.formsConfig.validationGroup);
  },
  computed: {
    setDataSource() {
      return UserTypeDataSource;
    },
  },
};
</script>

<style lang="scss"></style>
